import type { IconSvgObject } from './types';

const ShipWheelIcon: IconSvgObject = [
  ["circle", { cx: "11.9922", cy: "11.9939", r: "8", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14.9922 11.9939L21.9922 11.9938M1.99219 11.9938L8.99219 11.9939M11.9972 14.9939V22.0003M11.9967 1.99976L11.9922 8.9939", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14.4941 14.4939L19.0693 19.0667M4.92716 4.92456L9.49414 9.4939M9.49414 14.4939L4.92578 19.075M19.0686 4.93216L14.4941 9.4939", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }],
  ["circle", { cx: "11.9922", cy: "11.9939", r: "3", stroke: "currentColor", strokeWidth: "1.5", key: "3" }]
];

export default ShipWheelIcon;
